<template>
    <default-modal
        ref="box"
        :title="`设置服务器自动登录`"
        :modalWidth="600"
        :confirmTxt="`保存`"
        @confirm="confirm"
    >
        <div class="modal-body">
            <div>
                <p>
                    开启服务器免密登录后，当使用维护大师远程服务器时，将会出现一个维护大师免密用户，点击进入直接登录。
                </p>

                <div class="row">
                    <span class="left">免密登录开关：</span>
                    <div style="margin-left:120px;">
                        <switchc
                            :value="switchValue"
                            text="on|off"
                            @change="getAutoVal"
                        ></switchc>
                        <!-- <a href=#
                            @click="autoLogin=0"
                            v-show="autoLogin">开</a>
                        <a href=#
                            @click="autoLogin=1"
                            v-show="!autoLogin">关</a> -->
                    </div>
                </div>
                <div class="row">
                    <span class="left">当前服务器用户名：</span>
                    <input
                        class="default-input"
                        :class="{ 'input-bgc': switchValue }"
                        type="text"
                        v-model="loginName"
                    />
                </div>
                <div class="row">
                    <span class="left">当前服务器密码：</span>
                    <input
                        class="default-input"
                        :class="{ 'input-bgc': switchValue }"
                        type="text"
                        v-model="password"
                        placeholder="请输入登录密码"
                    />
                </div>
            </div>
        </div>
    </default-modal>
</template>
<script>
import DefaultModal from "_c/modals/defaultModal";
import switchc from "_c/switch/switch";

import { getAutoLoginInfo, updateBsAutoLoginInfo } from "@/requests/bar";
export default {
    components: {
        DefaultModal,
        switchc
    },
    data() {
        return {
            barId: "",
            flag: "",
            autoLogin: 1,
            loginName: "",
            password: "",
            switchValue: true
        };
    },
    mounted() {
        window.$modal.setServerAutoLogin = {};
        window.$modal.setServerAutoLogin.show = (barId, flag) => {
            this.show(barId, flag);
        };
    },
    methods: {
        // 初始化信息
        async show(barId, flag) {
            let res = await getAutoLoginInfo({
                barId,
                flag
            });
            if (res.loginName == null && res.password == null) {
                this.barId = res.barId;
                this.flag = res.flag;
                this.autoLogin = res.autoLogin;
                this.loginName = "";
                this.password = "";
                this.resetAuto();
                this.$refs.box.show();
            } else {
                this.barId = res.barId;
                this.flag = res.flag;
                this.autoLogin = res.autoLogin;
                this.loginName = res.loginName;
                this.password = res.password;
                this.resetAuto();
                this.$refs.box.show();
            }
        },
        resetAuto() {
            if (this.autoLogin == 1) {
                this.switchValue = true;
            } else {
                this.switchValue = false;
            }
        },
        getAutoVal(data) {
            if (data == true) {
                this.autoLogin = 1;
                this.switchValue = true;
            } else {
                this.autoLogin = 0;
                this.switchValue = false;
            }
        },
        async confirm() {
            if (this.loginName == "") {
                return this.$refs.box.setWrong("请输入用户名");
            }
            if (this.password == "") {
                return this.$refs.box.setWrong("请输入密码");
            }
            await updateBsAutoLoginInfo({
                barId: this.barId,
                flag: this.flag,
                autoLogin: this.autoLogin,
                loginName: this.loginName,
                password: this.password
            });
            this.$refs.box.hide();
            this.$refs.box.setWrong("");
        }
    }
};
</script>
<style lang="scss" scoped>
@import "_style/_color.scss";

.modal-body {
    padding: 10px;
    padding-left: 30px;
    padding-right: 30px;
    text-align: left;
    p {
        text-indent: 2em;
        line-height: 20px;
    }
    .row {
        height: 30px;
        line-height: 30px;
        margin-top: 10px;
        overflow: hidden;
        margin-left: 60px;
        .left {
            display: inline-block;
            float: left;
            min-width: 110px;
            margin-right: 10px;
            color: $gray-word;
        }
    }
    input {
        width: 250px;
        height: 30px;
        // background-color: rgba(242, 242, 242, 1);
        box-sizing: border-box;
        border-width: 1px;
        border-style: solid;
        border-color: rgba(230, 230, 230, 1);
        border-radius: 0px;
        font-size: 12px;
        color: #515151;
        text-align: left;
        padding-left: 10px;
    }
}
.input-bgc {
    background-color: #fff;
}
</style>
